import './tabs.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useHasPermission } from '../../hooks';

const Tabs = ({ tabList, baseUrl }) => {
  const { pathname } = useLocation();
  const IS_TAB_ROUTE =
    pathname !== baseUrl
      ? tabList.some((tab) => pathname.includes(`${baseUrl}/${tab.value}`))
      : true;

  const hasPermission = useHasPermission();

  const filteredTabList = Array.isArray(tabList)
    ? tabList.filter((tab) => !tab.hidden && (!tab.permission || hasPermission(tab.permission)))
    : tabList;

  return IS_TAB_ROUTE ? (
    <div className="tabs">
      <ul className="tabs__list">
        {filteredTabList &&
          filteredTabList.map(({ value, name }) => (
            <li className="tabs__list-item" key={value}>
              <NavLink
                to={`${baseUrl}/${value.toLowerCase()}`}
                className="tabs__button"
                activeClassName="tabs__button--active">
                {name}
              </NavLink>
            </li>
          ))}
      </ul>
    </div>
  ) : null;
};

Tabs.propTypes = {
  tabList: PropTypes.arrayOf(PropTypes.object),
  baseUrl: PropTypes.string
};

export { Tabs };
